import { render } from "./SupplierKPI.vue?vue&type=template&id=a90ae7c4&ts=true"
import script from "./SupplierKPI.vue?vue&type=script&lang=ts"
export * from "./SupplierKPI.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__